import { getHost } from '../utils/host'

export default function addDefaultHeaders({ $axios, req }) {
  $axios.onRequest((config) => {
    // req exists only on server-side, so we need to check for it in order to fill the Origin header.
    // On client-side the Origin is added automatically by the browser
    if (req) {
      const host = getHost(req)

      // Get protocol from x-forwarded-proto header or fall back to http
      // x-forwarded-proto is used as reverse proxies preserve the original protocol used by the client
      const protocol = req.headers['x-forwarded-proto'] || 'http'

      // needed for the hydration phase; we authenticate the catalog based on the Origin
      // and if the request is not made from the browser, the Origin header is not set
      config.headers.common.Origin = `${protocol}://${host}`
    }

    config.headers.common['X-Requested-With'] = 'catalog'
  })
}
